import { useMemo } from 'react';
// routes
import { paths } from 'src/routes/paths';
// components
import Iconify from 'src/components/iconify';

// ----------------------------------------------------------------------

const icon = (name) => (
  // <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
  // OR
  <Iconify icon={name} />
  // https://icon-sets.iconify.design/solar/
  // https://www.streamlinehq.com/icons
);

const ICONS = {
  staff: icon('clarity:employee-solid'),

  physics: icon('iconmind:physics-sim-outline-bold'),
  mcq: icon('healthicons:i-exam-multiple-choice'),

  announcement: icon('boxicons:announcement-filled'),

  account: icon('material-symbols:account-box'),
  security: icon('material-symbols:security')
};

// ----------------------------------------------------------------------

export function useNavData() {
  const data = useMemo(
    () => [
      // ASSIGNMENT
      // ----------------------------------------------------------------------
      {
        subheader: 'Assignment Management',
        items: [
          { title: 'MCQ', path: paths.dashboard.assignment.mcq, icon: ICONS.mcq }
        ]
      },

      // SYLLABUS
      // ----------------------------------------------------------------------
      {
        subheader: 'Syllabus Management',
        items: [
          { title: 'Physics', path: paths.dashboard.syllabus.physics, icon: ICONS.physics }
        ]
      },

      // USER
      // ----------------------------------------------------------------------
      {
        subheader: 'User Management',
        items: [
          { title: 'Staff', path: paths.dashboard.user.staff, icon: ICONS.staff }
        ]
      },

      // SITE
      // ----------------------------------------------------------------------
      {
        subheader: 'Site Management',
        items: [
          { title: 'Announcement', path: paths.dashboard.site.announcement, icon: ICONS.announcement }
        ]
      },

      // PROFILE
      // ----------------------------------------------------------------------
      {
        subheader: 'Profile',
        items: [
          { title: 'Account', path: paths.dashboard.profile.account, icon: ICONS.account },
          { title: 'Security', path: paths.dashboard.profile.security, icon: ICONS.security },
        ],
      },
    ],
    []
  );

  return data;
}
